import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Gruppe } from '../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { Haendler } from '../../../../projects/kiene-core/src/lib/components/stammdaten/haendler/haendler';
import { Betriebskontakt } from '../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';

@Component({
    selector: 'kiene-tiere-als-csvupload-dialog',
    templateUrl: './tiere-als-csvupload-dialog.component.html',
    styleUrls: ['./tiere-als-csvupload-dialog.component.scss'],
})
export class TiereAlsCSVUploadDialogComponent implements OnInit {
    gruppe: Gruppe;
    filesToUpload: File[] = [];
    filesProgressValues: number[] = [];
    einstalldatumCtrl = new UntypedFormControl(new Date(), [Validators.required]);
    viehhaendler: Haendler[] = [];
    viehhaendlerCtrl = new UntypedFormControl();
    abteilCtrl = new UntypedFormControl();
    bemerkungCtrl = new UntypedFormControl();
    hitMeldenCtrl = new UntypedFormControl(undefined, [Validators.required]);
    isLoading = false;
    selectedBetriebskontakt: Betriebskontakt | null = null;

    @ViewChild('fileSelector') fileSelector: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<TiereAlsCSVUploadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly http: HttpClient,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
    ) {}

    ngOnInit(): void {
        this.gruppe = this.data.gruppe;
        this.loadViehhaendler();
    }

    loadViehhaendler() {
        const params = new HttpParams().set('favorit', '1');
        this.api.get(this.apiBaseUrl + 'viehhaendler/read_kundenportal.php', params).subscribe({
            next: response => {
                this.viehhaendler = response.records;
            },
        });
    }

    openFileSelector() {
        this.fileSelector?.nativeElement?.click();
    }

    handleFile(event: any) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            this.filesToUpload.push(files.item(i));
            this.filesProgressValues[i] = 0;
        }
    }

    onBetriebskontaktSelected(kontakt: Betriebskontakt) {
        this.selectedBetriebskontakt = kontakt;
        // Wenn ein Betriebskontakt ausgewählt wird, Händler zurücksetzen
        if (kontakt) {
            this.viehhaendlerCtrl.setValue(null);
        }
    }

    onBetriebskontaktEntfernen() {
        this.selectedBetriebskontakt = null;
    }

    uploadFilesToServer() {
        this.isLoading = true;
        if (this.filesToUpload.length > 0) {
            for (let i = 0; i < this.filesToUpload.length; i++) {
                const fileNumber = i;
                const file = this.filesToUpload[fileNumber];

                const fd = new FormData();
                fd.append('gruppe_id', this.gruppe.gruppe_id.toString());
                if (this.gruppe?.kunde_id) {
                    fd.append('kunde_id', this.gruppe.kunde_id.toString());
                }

                fd.append('dokument', file);
                fd.append('kp_einstalldatum', (<Date>this.einstalldatumCtrl.value)?.toISOString());
                
                // Betriebskontakt hat Priorität vor Legacy-Händler
                if (this.selectedBetriebskontakt?.kunde_id) {
                    fd.append('betriebskontakt_haendler_id', this.selectedBetriebskontakt.kunde_id.toString());
                } else if (this.viehhaendlerCtrl.value) {
                    fd.append('viehhaendler_id', this.viehhaendlerCtrl.value?.viehhaendler_id?.toString());
                }
                if (this.abteilCtrl.value) {
                    fd.append('abteil', this.abteilCtrl.value);
                }
                if (this.bemerkungCtrl.value) {
                    fd.append('bemerkung', this.bemerkungCtrl.value);
                }
                fd.append('hit_meldung', this.hitMeldenCtrl.value?.toString());

                const params = new HttpParams();

                const options = {
                    headers: new HttpHeaders('Phito-Type: fileupload'),
                    params: params,
                    reportProgress: true,
                };

                this.http

                    .post<any>(this.apiBaseUrl + 'gruppe_tier/create_kundenportal_excel.php', fd, options)
                    .subscribe({
                        next: event => {
                            if (event.type === HttpEventType.UploadProgress) {
                                const percentDone = Math.round((100 * event.loaded) / event.total);
                            }
                        },
                        error: err => {
                            this.isLoading = false;
                            this.messageService.errorMessage('Fehler beim Hochladen!', err);
                        },
                        complete: () => {
                            this.filesProgressValues[fileNumber] = 1;
                            if (fileNumber === this.filesToUpload.length) {
                                this.isLoading = false;
                            }
                            this.messageService.infoMessage('Datei(en) erfolgreich hochgeladen!');
                            this.dialogRef.close(true);
                        },
                    });
            }
        }
    }
}
